<template>
  <div class="w-100">
    <vz-cargo-general :order-lock="disabled" />
    <div class="vz-individual-order-cargo-pallets-cards">
      <vz-cargo-card
        v-for="(item, index) in palletItems"
        :key="item.key"
        :title="item.label"
        :disabled="isOnlyOne"
        @remove="removeCard(index)"
        @copy="copyCard(index)"
        @update:title="orderStore.orderForm.cargo.pallets.items[index].label = $event"
      >
        <vz-select
          :modelValue="getItemParam('type', index)"
          :items="palletTypes"
          :no-empty="true"
          :disabled="disabled"
          label="Тип"
          class="vz-cargo-card-type"
          @update:modelValue="setType(index, $event)"
          @change="orderStore.getOrderPriceAction"
        />
        <vz-cargo-dimension
          :detail="getItem(index)"
          :wrapping="getItem(index).wrapping"
          :count="getItem(index).count"
          :disabled="disabled"
          :disabled-fields="getDisabledFields(index)"
          :interactive="false"
          has-count
          class="mt-5"
          @change-detail-param="onChangeItemParam(index, $event)"
        />
      </vz-cargo-card>
    </div>
    <vz-cargo-hint />
    <vz-button
      icon-name="plus"
      variant="primary"
      outline
      big
      class="add-card-button"
      :disabled="disabled"
      @click="addCard"
    >
      Добавить
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import {palletTypes} from '~/common/objects';
import {OrderDimensionDetail} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import VzCargoGeneral from '~/components/personal/order/cargo/parts/vz-cargo-general.vue';
import VzCargoCard from '~/components/personal/order/cargo/parts/vz-cargo-card.vue';
import VzCargoDimension from '~/components/personal/order/cargo/parts/vz-cargo-dimension.vue';
import VzCargoHint from '~/components/personal/order/cargo/parts/vz-cargo-hint.vue';
import useOrderCargo from '~/composables/useOrderCargo';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()
const {
  items: palletItems,
  isOnlyOne,
  getItem,
  getItemParam,
  onChangeItemParam,
  addCard,
  copyCard,
  removeCard
} = useOrderCargo('pallets')

function getDisabledFields(index: number): Array<keyof OrderDimensionDetail> {
  return orderStore.orderForm.cargo.pallets.items[index].type === 'nonStandard'
    ? []
    : ['length', 'width']
}

function setType(index: number, value: string) {
  if (orderStore.orderForm.cargo.pallets.items[index].type === value) {
    return
  }
  orderStore.orderForm.cargo.pallets.items[index].type = String(value)

  const type = palletTypes.find(i => i.value === value)
  if (type) {
    orderStore.orderForm.cargo.pallets.items[index].length = type.length
    orderStore.orderForm.cargo.pallets.items[index].width = type.width
  }
}
</script>
